import * as React from "react";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { OAC } from "../../../Common/AdviserCharges/Components/OAC";
import { LessThanAge, PensionHelper } from "../../../Common/Helpers/PensionHelper";
import { DrawdownCalculationAction } from "../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { ProtectionInformation } from "../../../Common/SIPP/DrawdownDetails/ProtectionInformation";
import { CrystallisationDetailsSection } from "../../../Common/SIPP/DrawdownDetails/CrystallisationDetailsForTopUp";
import { CrystallizationPerContribution } from "../../../Common/SIPP/DrawdownDetails/CrystallizationPerContribution";
import { DIAC } from "../../../Common/SIPP/DrawdownDetails/DIAC";
import { DrawdownPriceLock } from "../../../Common/SIPP/DrawdownDetails/DrawdownPriceLock";
import { DrawdownTypeOption } from "../../../Common/SIPP/DrawdownDetails/DrawdownType";
import {
    calculateAvailableToCrystallise,
    getChooseAssetsToSellTable,
    getChooseAssetsToSwitchTable,
    getSellableAssets,
    hasEnhancedPensionProtection,
    hasPrimaryProtection,
    hasEnhancedProtectionWithPclsProtection
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { IllHealth } from "../../../Common/SIPP/DrawdownDetails/IllHealth";
import { Information } from "../../../Common/SIPP/DrawdownDetails/Information";
import { LTABreakdownDetails } from "../../../Common/SIPP/DrawdownDetails/LTABreakdownDetails";
import { PensionProtection } from "../../../Common/SIPP/DrawdownDetails/PensionProtection";
import { PreADayPensionDetails } from "../../../Common/SIPP/DrawdownDetails/PreADayPensionDetails";
import {
    ChooseAssetsToSellAssets,
    ChooseAssetsToSwitchAssets,
} from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { TaxFreeLumpSumPayment } from "../../../Common/SIPP/DrawdownDetails/TaxFreeLumpSumPayment";
import { ITFLSAction } from "../../Actions/ITFLSAction";
import { TopUpWithITFLSStore } from "../../Stores/Variable";
import { InvestmentPathSelection } from "../../../Common/SIPP/DrawdownDetails/InvestmentPathSelection";
import { DeferredFundWarningMessage, IsRestrictedToPensionContributionWarningText } from "../../../Common/Resource/Contents";
import { PensionArrangementType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { PensionArrangementOrigin } from "../../../../../../../Wrap/Constants/Enums/Drawdown/PensionArrangementOrigin";
import { ChargesOnIllustration } from "../../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { isRestrictedToPensionContribution } from "../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { HistoricCrystallisationPage } from "../../../../../../../Wrap/Models/Domains/Drawdown/HistoricCrystallisationPage";
import { AllowanceDetails } from "../../../Common/SIPP/DrawdownDetails/AllowanceDetails";
import { ExistingContributionDispatcher } from "../../../EditIncomeDrawdownWizard/Stores/Variable";
import { ActionType } from "../../../../../../../react-core/Flux/ActionType";
import { UserStore } from "../../../../../Stroes/Variable";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { CrystallisationOption } from "../../../../../../../Wrap/Constants/Enums/Drawdown/CrystallisationOption";
import _ from "lodash";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { ContributionAndWithdrawalBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ContributionAndWithdrawalBase";

interface IDrawdownDetailsProps extends IProcessComponentProps {
    data: PensionContributionModel;
    customerId?: number;
}

interface IDrawdownDetailsState {
    isLoading: boolean;
    originType: DrawdownType;
    assetsTable: ChooseAssetsToSellAssets[];
    assetsToSwitchTable: ChooseAssetsToSwitchAssets[];
    hasExistingOnPlatformCappedDrawdown: boolean;
    hasExistingOnPlatformFlexiDrawdown: boolean;
    historicCrystallisation: HistoricCrystallisationPage;
    AdviceGiven: boolean;
    userInfo: User;
    isDisinvest: Boolean;
}

export class Drawdown extends ProcessComponent<IDrawdownDetailsProps, IDrawdownDetailsState> {
    private didInitialCalculation: boolean = false;
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            originType: null,
            assetsTable: [],
            assetsToSwitchTable: [],
            hasExistingOnPlatformCappedDrawdown: false,
            hasExistingOnPlatformFlexiDrawdown: false,
            historicCrystallisation: null,
            AdviceGiven: false,
            userInfo: UserStore.getUserInfo(),
            isDisinvest: true,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        if (!this.props.data.Contribution?.AdviceGiven) {
            this.onDataChange(this.props.onChange, { AdviceGiven: true }, this.props.data, "Contribution");
        }
        this.setState({AdviceGiven : this.props.data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers.PersonalRecommendation ?? false})

        getSellableAssets(
            getQueryParameters()["type"],
            getQueryParameters()["hierarchyid"],
            getQueryParameters()["subaccounthierarchyid"],
            (data) => {
                this.setState({
                    assetsTable: getChooseAssetsToSellTable(this.props.data.Contribution, false, data.assetsToSell),
                }, () => {
                    this.updatePensionCommencementLumpSumAllocations();
                });
                this.setState({
                    assetsToSwitchTable: getChooseAssetsToSwitchTable(
                        this.props.data.Contribution,
                        data.assetsToSwitch
                    ),
                });
            }
        );

        if (
            !this.ageNeedIllHealth(this.props.data) &&
            !this.props.data?.Contribution?.DrawdownModel?.InstructionId
        ) {
            this.postDrawdownInstruction();
        }

        this.checkDeferredFunds(this.state.assetsTable);

        ITFLSAction.getPensionArrangement(
            this.props.data.Contribution.ExistingPensionSubAccountHierarchyId,
            false,
            (result) => {
                var exists = result.some((arrangement) => {
                    return (
                        arrangement.Type == PensionArrangementType.Capped &&
                        arrangement.Origin != PensionArrangementOrigin.Transfer
                    );
                });

                this.setState({ hasExistingOnPlatformCappedDrawdown: exists });

                this.setState({ hasExistingOnPlatformFlexiDrawdown:
                    result.some((arrangement) => {
                        return (
                            arrangement.Type == PensionArrangementType.Fad &&
                            arrangement.Origin != PensionArrangementOrigin.Transfer
                        );
                    })
                });
            }
        );
        ITFLSAction.getHistoricCrystallisation(
            this.props.data.Contribution.ExistingPensionSubAccountHierarchyId,
            (result) => {
                this.setState({ historicCrystallisation: result });
            }
        );
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if (
            this.props.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets != undefined &&
            prevProps.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets !=
                this.props.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets
        ) {
            this.setIsDisinvest();
        }

        if (!this.didInitialCalculation &&
            this.props.data?.Contribution?.DrawdownModel?.CrystallisationDetails?.CrystallisationOption
        ) {
            this.doCalculation();
            this.didInitialCalculation = true;
        }

        if (
            JSON.stringify(prevProps.data?.Contribution?.DrawdownModel) !== 
            JSON.stringify(this.props.data?.Contribution?.DrawdownModel)) 
        {
            this.updatePensionCommencementLumpSumAllocations();
        }
    }

    private setUpCrystallisationAmount(data: PensionContributionModel) {
        if (data.Contribution.DrawdownModel?.CrystallisationDetails?.CrystallisationAmount
            && data.Contribution.DrawdownModel?.CrystallisationDetails?.CrystallisationAmount.Amount == 0) {

            const drawdownModel = data?.Contribution?.DrawdownModel
            const fullAmount = calculateAvailableToCrystallise(data?.Contribution, ProcessType.TopUpWithITFLS, true);

            drawdownModel.CrystallisationDetails.CrystallisationAmount = { Amount: fullAmount, Currency: CurrencyCode.GBP };
            drawdownModel.CrystallisationDetails.CrystallisationOption = !drawdownModel.CrystallisationDetails?.CrystallisationOption
                ? CrystallisationOption.Full
                : drawdownModel?.CrystallisationDetails?.CrystallisationOption;
        }
    }

    private checkDeferredFunds(assets: ChooseAssetsToSellAssets[]) {
        let deferredInstrumentCodes = assets.filter((a) => a.IsDeferred).map((o) => o.Assets);
        let message = DeferredFundWarningMessage.CannotSwitchFromDeferredFundWarning.replace(
            "<InstrumentCode>",
            deferredInstrumentCodes.join(",")
        );
        this.props.showErrorMsgPopUp([message]);
    }

    private postDrawdownInstruction(isIllHealth: boolean = false) {
        this.setState({ isLoading: true });
        const params = getQueryParameters();
        DrawdownCalculationAction.postDrawdown(
            this.props.data?.Contribution?.HierarchyId,
            null,
            (drawdownModel: DrawdownModel) => {
                ITFLSAction.getInstruction(
                    params["id"],
                    params["hierarchyid"],
                    this.props.customerId,
                    (result) => {
                        this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                        this.setUpCrystallisationAmount(result);
                        ExistingContributionDispatcher.dispatch({
                            actionType: ActionType.Success,
                            payload: result,
                        });
                    }
                );
            },
            isIllHealth
        );
    }

    private getComponentProps = (data: PensionContributionModel, onChange) => {
        const { ChargesExtraInfo, DrawdownModel } = data.Contribution;
        if (DrawdownModel && !DrawdownModel.ChargesExtraInfo && ChargesExtraInfo) {
            data.Contribution.DrawdownModel.ChargesExtraInfo = ChargesExtraInfo;
        }
        
        return {
            data: data?.Contribution?.DrawdownModel,
            onChange: (v) =>
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                    v,
                    data.Contribution,
                    "DrawdownModel"
                ),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
            hierarchyId: this.props.data?.Contribution?.HierarchyId,
        };
    };

    private updatePensionCommencementLumpSumAllocations() {
        const { data } = this.props;
        const drawdownModel = data?.Contribution?.DrawdownModel;
        if (!drawdownModel || drawdownModel.DrawdownType == DrawdownType.Regular) return;
        
        const availableCash = drawdownModel?.CrystallisationDetails?.AvailableCash?.Amount || 0;
        const pclsAmount = drawdownModel?.TaxFreeLumpSum?.Amount || 0;
        
        if (!this.state.assetsTable || this.state.assetsTable.length === 0) return;
        
        const cashAsset = this.state.assetsTable.find(a => a.Assets.toUpperCase() === "GBP CASH");
        if (!cashAsset) return;
        
        if (availableCash >= pclsAmount) {
            const pclsAllocations = [{
                ProductId: cashAsset.Id,
                Name: cashAsset.Assets,
                Percentage: 100,
                Type: cashAsset.ProductType
            }];

            const changes = {
                PensionCommencementLumpSumAllocations: pclsAllocations
            };
            
            this.onDataChange(
                (changeData) => this.onDataChange(this.props.onChange, changeData, data, "Contribution"),
                changes,
                this.props.data.Contribution,
                "DrawdownModel"
            );
        }
    }

    private setIsDisinvest(assetsTable: ChooseAssetsToSellAssets[] = []) {
        let assetData = this.state.assetsTable.length > 0 ? this.state.assetsTable : assetsTable;
        let assetAllocations = this.props.data?.Contribution?.DrawdownModel?.PensionCommencementLumpSumAllocations;
        let isAcrossAllAssets = this.props.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets ?? true;

        //if the asset allocation got 100% cash, then disinvestment is not needed
        if (
            (isAcrossAllAssets && assetData && assetData.length == 1) ||
            (!isAcrossAllAssets &&
                assetAllocations &&
                assetData &&
                assetData.some(
                    (x) =>
                        x.Assets.toUpperCase() == "GBP CASH" &&
                        assetAllocations.some((y) => y.ProductId == x.Id && y.Percentage == 100)
                ))
        ) {
            this.setState({
                isDisinvest: false,
            });
            return;
        }

        this.setState({
            isDisinvest: true,
        });
    }

    private doCalculation = () => {
        this.setState({ isLoading: true });
        const { customerId } = this.props;
        const originType =
            this.state.originType || TopUpWithITFLSStore.getData()?.Contribution?.DrawdownModel?.DrawdownType;
        const currType = this.props.data?.Contribution?.DrawdownModel?.DrawdownType;
        const _data = JSON.parse(JSON.stringify(this.props.data));
        this.setState({ originType: currType });
        const originIsRegular = originType == DrawdownType.Regular;
        const currIsRegular = currType == DrawdownType.Regular;
        _data.Contribution.DrawdownModel.ChangeInstructionType =
            (originIsRegular && !currIsRegular) || (!originIsRegular && currIsRegular);
        ITFLSAction.saveInstruction(4, _data, null, customerId, (ressult) => {
            this.setState({ isLoading: false });
        });
    };

    private needIllHealth(data: PensionContributionModel) {
        return (
            this.ageNeedIllHealth(data) &&
            !data?.Contribution?.DrawdownModel?.InstructionId
        );
    }

    private ageNeedIllHealth(data: PensionContributionModel) {
        return data?.Contribution?.PensionProtection?.PensionSchemeSpecificProtection?.ProtectedRetirementAge
            ? false
            : LessThanAge(55, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
    }

    private setAdviseGiven(v) {
        this.onDataChange(
            (changes) => this.onDataChange(this.props.onChange, changes, this.props.data, "Contribution"),
            { AdviceGiven: v.PersonalRecommendation },
            this.props.data.Contribution,
            "FinancialAdvice"
        );
        this.onDataChange(
            this.props.onChange,
            { AdviceGiven: v.PersonalRecommendation },
            this.props.data,
            "Contribution"
        );
    }

    isValid() {
        if (this.props.data?.Contribution?.DrawdownModel?.PreADay) {
            this.props.showErrorMsgPopUp(["Cancel the process unless select 'No' for Pre-A-Day pension details"]);
        }
        var isNotFirstCrystallisation = this.state?.historicCrystallisation?.TotalRows > 0;
        if (!this.state.AdviceGiven && !isNotFirstCrystallisation && !UserStore.getUserInfo().IsInternalUser) {
            this.props.showErrorMsgPopUp(["To continue, you must have given financial advice."]);
            return false;
        }
        var isRestrictedProtection = false;
        if (this.props.data?.Contribution?.HasPensionProtection && this.props.data?.Contribution?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                this.props.data?.Contribution?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }
        return (
            super.isValid() && this.props.data?.Contribution?.DrawdownModel?.PreADay == false && !isRestrictedProtection
        );
    }

    private getTotalPea(data: PensionContributionModel) {
        if (this.state.assetsTable?.length === 0) return;

        const preRetirementPea = PensionHelper.getPaymentsPeaTotal(data?.Contribution?.PreRetirementInstrumentSelections?.Instruments);
        const postRetirementPea = PensionHelper.getPaymentsPeaTotal(data?.Contribution?.PostRetirementInstrumentSelections?.Instruments);
        const transferPea = PensionHelper.getTransfersPeaTotal(data?.Contribution?.PensionTransfers);

        const drawdownModel = data?.Contribution?.DrawdownModel;
        const taxFreeLumpSum = drawdownModel?.TaxFreeLumpSum?.Amount ?? 0;

        let disinvestmentPea = 0;

        if (drawdownModel?.CrystallisationDetails?.AvailableCash?.Amount < taxFreeLumpSum) {
            if (drawdownModel?.IsAcrossAllAssets) {
                const assetsAmount = this.state.assetsTable
                    .filter((asset) => asset.ProductType !== ProductType.OffPlatform && asset.ProductType !== ProductType.Cash)
                    .reduce((total, asset) => total + asset.MarketValue.Amount, 0);

                const totalAmount = this.state.assetsTable
                    .filter((asset) => asset.ProductType !== ProductType.OffPlatform)
                    .reduce((total, asset) => total + asset.MarketValue.Amount, 0);

                if (totalAmount > 0) {
                    disinvestmentPea = (assetsAmount / totalAmount) * taxFreeLumpSum;
                }
            } else {
                disinvestmentPea = PensionHelper.getDisinvestmentPeaTotal(drawdownModel?.PensionCommencementLumpSumAllocations, taxFreeLumpSum);
            }
        }

        return preRetirementPea + postRetirementPea + transferPea + taxFreeLumpSum - disinvestmentPea;
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const { hasExistingOnPlatformCappedDrawdown, hasExistingOnPlatformFlexiDrawdown, userInfo, assetsTable } = this.state;
        const isNotFirstCrystallisation = this.state?.historicCrystallisation?.TotalRows > 0;
        const ageLessThan75 = LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
        const isImmediateTaxFreeLumpSum = true;
        const hasOuterRingAssets = assetsTable.some(x => x.ProductType === ProductType.OffPlatform);
        
        if (this.needIllHealth(data)) {
            return (
                <IllHealth
                    {...this.getComponentProps(data, onChange)}
                    getDrawdownModel={() => {
                        this.postDrawdownInstruction(true);
                    }}
                />
            );
        }
        return (
            <PartLoading isLoading={this.state.isLoading}>
                <h2>Drawdown details</h2>
                <>
                    <PreADayPensionDetails {...this.getComponentProps(data, onChange)} />
                    {data?.Contribution?.DrawdownModel?.PreADay == false && (
                        <>
                            <PensionProtection
                                {...this.props}
                                onRef={(ref) => this.appendChild(ref)}
                                data={data?.Contribution}
                                onChange={(v) => this.onDataChange(onChange, v, data, "Contribution")}
                                process={ProcessType.TopUpWithITFLS}
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                            />
                            <ProtectionInformation
                                {...this.getComponentProps(data, onChange)}
                                process={ProcessType.TopUpWithITFLS}
                                pensionProtection={data?.Contribution?.PensionProtection}
                            />

                            <InvestmentPathSelection
                                onRef={(ref) => this.appendChild(ref)}
                                data={data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers}
                                activityType={data?.ActivityType}
                                isFirstCrystallisation = {!isNotFirstCrystallisation}
                                onChange={(v) => {
                                    this.setState({AdviceGiven: v.PersonalRecommendation})
                                    this.onDataChange(
                                        (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                        { InvestmentPathwayAnswers: v },
                                        data.Contribution,
                                        "DrawdownModel"
                                    );
                                    this.setAdviseGiven(v);
                                }}
                                hardBlockforAdviserUser={userInfo?.IsAdviser && !hasExistingOnPlatformCappedDrawdown && !hasExistingOnPlatformFlexiDrawdown}
                                hasOuterRingAssets={hasOuterRingAssets}
                            />

                            <hr />

                            <DrawdownTypeOption
                                isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                                originType={
                                    this.state.originType ||
                                    TopUpWithITFLSStore.getData()?.Contribution?.DrawdownModel?.DrawdownType
                                }
                                {...this.getComponentProps(data, onChange)}
                                pensionProtection={data?.Contribution?.PensionProtection}
                                activityType={data?.ActivityType}
                                hasExistingOnPlatformCappedDrawdown={hasExistingOnPlatformCappedDrawdown}
                                PersonalRecommendation={
                                    data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers
                                        ?.PersonalRecommendation ?? data?.Contribution?.FinancialAdvice?.AdviceGiven
                                }
                            />
                        </>
                    )}
                  
                    {data?.Contribution?.DrawdownModel?.PreADay == false && (
                        <>
                            {(data?.Contribution?.DrawdownModel.DrawdownType == DrawdownType.Capped ||
                                data?.Contribution?.DrawdownModel.DrawdownType == DrawdownType.Flexible) && (
                                <CrystallisationDetailsSection
                                    isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                                    modelData={this.props.data?.Contribution}
                                    processType={ProcessType.TopUpWithITFLS}
                                    cashInstrmentProductId={data?.CashInstrument?.ProductId || 0}
                                    doCalculation={() => this.doCalculation()}
                                    {...this.getComponentProps(data, onChange)}
                                    pensionProtection={data?.Contribution?.PensionProtection}
                                />
                            )}
                            {(data?.Contribution?.DrawdownModel?.AllowanceDetails?.HasOffPlatformBcePriorApril2024 && !data?.Contribution?.DrawdownModel?.AllowanceDetails?.AwareOfBCEAmounts) &&
                                !hasPrimaryProtection(data?.Contribution?.PensionProtection) && !hasEnhancedProtectionWithPclsProtection(data?.Contribution?.PensionProtection) && (
                                <>
                                    <LTABreakdownDetails
                                        doCalculation={() => this.doCalculation()}
                                        {...this.getComponentProps(data, onChange)}
                                        process={ProcessType.TopUpWithITFLS}
                                        lessThan75={ageLessThan75}
                                        hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                                    />
                                </>
                            )}
                             <AllowanceDetails
                                doCalculation={() => this.doCalculation()}
                                {...this.getComponentProps(data, onChange)}
                                pensionProtection={data?.Contribution?.PensionProtection}
                                hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                                process={ProcessType.TopUpWithITFLS}
                            />
                            <TaxFreeLumpSumPayment
                                doCalculation={this.doCalculation}
                                process={ProcessType.TopUpWithITFLS}
                                pensionProtection={data?.Contribution?.PensionProtection}
                                {...this.getComponentProps(data, onChange)}
                                lessThan75={LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth))}
                                hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                            />

                            <CrystallizationPerContribution
                                {...this.getComponentProps(data, onChange)}
                                modelData={this.props.data?.Contribution}
                                process={ProcessType.TopUpWithITFLS}
                            />

                            {data?.Contribution?.DrawdownModel?.DrawdownType != DrawdownType.Regular && (
                                <DIAC
                                    {...this.getComponentProps(data, onChange)}
                                    modelData={this.props.data?.Contribution}
                                    existingAccount={true}
                                />
                            )}
                            <OAC
                                readonly={true}
                                type={SubAccountType.Npr}
                                onChange={(v) => {}}
                                data={{
                                    OngoingAdviceCharge:
                                        data?.Contribution?.DrawdownModel?.DrawdownAdviserCharge?.OngoingAdviserCharge,
                                }}
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                onRef={(ref) => this.appendChild(ref)}
                            />
                            <ChargesOnIllustration {...this.getComponentProps(data, onChange)} />

                            <DrawdownPriceLock
                                {...this.getComponentProps(data, onChange)}
                                subaccountHierarchyId={getQueryParameters()["subaccounthierarchyid"]}
                                totalPea={this.getTotalPea(data)}
                            />
                        </>
                    )}
                </>
            </PartLoading>
        );
    }
}
